export default __webpack_public_path__ + "static/media/people.5a6ebe1e.svg";